export default {

        skills: [
            { name: 'PHP', image: require('~/../images/svg/php.svg') },
            { name: 'Go', image: require('~/../images/svg/go.svg') },
            { name: 'Rust', image: require('~/../images/svg/rust.svg') },

            { name: 'HTML5', image: require('~/../images/svg/html_.svg') },
            { name: 'JS', image: require('~/../images/svg/js_2.svg') },
            { name: 'CSS3', image: require('~/../images/svg/css_2.svg') },
            { name: 'Vue', image: require('~/../images/svg/vue-js.svg') },

            { name: 'Webpack', image: require('~/../images/svg/webpack.svg') },
            { name: 'Sass', image: require('~/../images/svg/sass.svg') },
            { name: 'ECMA6', image: require('~/../images/svg/es6.svg') },

            { name: 'WordPress', image: require('~/../images/svg/wp_clean.svg') },
            { name: 'SaaS', image: require('~/../images/svg/saas.svg') },
            { name: 'REST API', image: require('~/../images/svg/api.svg') },
            { name: 'Console', image: require('~/../images/svg/console.svg') },
        ],

        tools: [
            { name: 'Windows', image: require('~/../images/svg/win.svg') },
            { name: 'Mac', image: require('~/../images/svg/apple.svg') },
            { name: 'Atom', image: require('~/../images/svg/atom.svg') },

            // { name: 'Brackets', image: require('~/../images/svg/brackets.svg') },
            { name: 'Docker', image: require('~/../images/svg/docker_.svg') },
            { name: 'Composer', image: require('~/../images/svg/composer.svg') },
            { name: 'Node', image: require('~/../images/svg/node.svg') },
            { name: 'Git', image: require('~/../images/svg/git_2.svg') },

            { name: 'Postman', image: require('~/../images/svg/postman.png') },

            { name: 'Apache', image: require('~/../images/svg/apache.svg') },
            { name: 'Ngnix', image: require('~/../images/svg/nginx.svg') },

            { name: 'Redis', image: require('~/../images/svg/redis.svg') },
            { name: 'MySQL', image: require('~/../images/svg/mysql.svg') },

            { name: 'Vagrant', image: require('~/../images/svg/vagrant.svg') },
            { name: 'Valet', image: require('~/../images/svg/laravel.svg') },

            { name: 'Chrome', image: require('~/../images/svg/chrome.svg') },
            { name: 'Safari', image: require('~/../images/svg/safari.svg') },
            { name: 'Firefox', image: require('~/../images/svg/ff.svg') },
            { name: 'Edge', image: require('~/../images/svg/ie.svg') },

        ],

        work : [
              {
                  'time'    : '01/2019 - heute',
                  'company' : 'Gkiokan.NET',
                  'job'     : 'Owner & Fullstack Web Developer <br>' +
                              'Enterprise Web App Development<br>' +
                              'WordPress Enterprise <br>' +
                              'SaaS Products <br>'
              },
              {
                  'time'    : '01/2017 - 12/2018',
                  'company' : 'Buero von Grau GmbH | GREYD GmbH',
                  'job'     : 'Fullstack Web Developer<br>' +
                              'Professional Business Web Application Development<br>' +
                              'WordPress Enterprise Development'
              },
              {
                  'time'    : '09/2013 - 12/2016',
                  'company' : 'IT Dienstleistung & Handel GmbH',
                  'job'     : 'Fullstack Web Developer<br>' +
                              'Business Web Application Development'
              },
              {
                  'time'    : '06/2006 - heute',
                  'company' : 'Gkiokan.NET',
                  'job'     : 'Webentwicklung vom Hobby zum Beruf <br>' +
                              'Externe Game-Control-Platformen <br>' +
                              'Games Debugging Hacking <br>' +
                              'Konsolen Debugging <br>'
              },
              // development less stuff below here
              {
                  'time'    : '07/2012 - 07/2013',
                  'company' : 'ITT Computer',
                  'job'     : 'IT-Techniker'
              },
              {
                  'time'    : '07/2011 - 07/2012',
                  'company' : 'Klaus Vitti GmbH',
                  'job'     : 'Qualitätsmanagement'
              },
              {
                  'time'    : '02/2011 - 05/2014',
                  'company' : 'CarBeautyCare',
                  'job'     : 'Autoaufbereitung Tuning und Entwicklungen fürs Auto'
              },


              {
                  'time'    : '12/2008 - 06/2009',
                  'company' : 'Arwe GmbH bei BMW & Mercedes-Benz',
                  'job'     : 'Fahrzeugaufbereiter & Transferfahrer'
              },
              {
                  'time'    : '08/2008 - 11/2008',
                  'company' : 'Griechisches Militär',
                  'job'     : 'Soldat (Infanterie) im grischen Militär'
              },
              {
                  'time'    : '02/2008 - 07/2008',
                  'company' : 'Arwe GmbH bei BMW Fröttmanning',
                  'job'     : 'Fahrzeugaufbereiter'
              }
        ],


        school : [
              {
                  'time'    : '09/2013 - 08/2016',
                  'company' : 'Städt. Berufsschule für Informationstechnik',
                  'job'     : 'Fachinformatiker FR. Anwendungsentwicklung'
              },
              {
                  'time'    : '02/2005 - 07/2006',
                  'company' : 'Hauptschule M-Zweig in Unterschleißheim',
                  'job'     : 'M10<br>Mittlere Reife'
              },
              {
                  'time'    : '02/2000 - 07/2005',
                  'company' : 'Hauptschule in Oberschleißheim',
                  'job'     : 'Qualifizierter Hauptschulabschluss'
              },
              {
                  'time'    : '09/1996 - 02/2000',
                  'company' : 'Grundschule am Stadtturm',
                  'job'     : ''
              }
        ],

        socialmedia: [
            { name: 'Xing', url: '//xing.com/profile/Gkiokan_Sali/cv' },
            { name: 'LinkedIn', url: '//linkedin.com/in/gkiokan/' },
            { name: 'GitHub', url: '//github.com/gkiokan' },
            { name: 'StackOverflow', url: '//stackoverflow.com/cv/gkiokan' },
        ],

        plattforms: [
            { name: 'Twitter', url: '//twitter.com/gkiokan' },
            { name: 'Pinterest', url: '//pinterest.com/gkiokan1337' },
            { name: 'YouTube', url: '//www.youtube.com/c/GkiokanSali' },
            { name: 'Facebook', url: '//facebook.com/GkiokanNET' },
            { name: 'Instagram', url: '//instagram.com/gkiokan.sali' }
        ]


}
